<template>
  <div>
    <div v-if="showIndex">
      <div class="pb-2">
        <h5>
          Usuarios
          <b-button pill size="sm" variant="primary" class="ml-2" v-on:click="onClickCreate()">
            <font-awesome-icon icon="plus" />
          </b-button>
        </h5>
      </div>

      <b-row class="mt-4 pt-1">
        <b-col lg="4" sm="6" md="6">
          <b-form-group
            label="Registros por página"
            label-cols="6"
            label-cols-sm="6"
            label-cols-md="6"
            label-cols-lg="5"
            label-align-sm="left"
            label-size="sm"
            label-for="perPageSelect"
            class="mb-0"
          >
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col offset-lg="4" lg="4" sm="6" md="6">
          <b-form-group lg="6" align="right">
            <b-input-group size="sm">
              <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Filtrar"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-table
          id="my-table"
          show-empty
          :fields="fields"
          :items="items"
          :per-page="perPage"
          :current-page="currentPage"
          :dark="true"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
          responsive
          hover
        >
          <template
            v-slot:cell(first_name)="data"
          >{{ data.item.first_name }} {{ data.item.last_name}}</template>

          <template
            v-slot:cell(documen)="data"
          >{{ data.item.type_document.description }} {{ data.item.documen }}</template>

          <template v-slot:cell(is_active)="data">
            <input
              type="checkbox"
              :Id="data.item.id"
              v-model="data.item.is_active"
              @click="onChangeStatusUser($event)"
            />
          </template>

          <template v-slot:cell(roles)="data">{{ parserArrayTable(data.item.roles) }}</template>

          <template v-slot:cell(action)="data">
            <a size="sm" @click="data.toggleDetails" class="text-info">
              <span v-if="data.detailsShowing">
                <font-awesome-icon icon="minus-circle" />
              </span>
              <span v-else>
                <font-awesome-icon icon="info-circle" />
              </span>
            </a>

            <a class="text-primary" title="Editar" @click="onClickEdit(data.item.id)">
              <font-awesome-icon icon="edit" />
            </a>            
          </template>

          <template v-slot:row-details="row">
            <b-card>
              <ul>
                <li>RH: {{ row.item.rh.description }}</li>
                <li>Genero: {{ row.item.gender == 'M' ? 'Masculino':'Femenino' }}</li>
                <li>Correo: {{ row.item.email }}</li>
                <li>Télefono: {{ row.item.phone_number }}</li>
                <li>Especialidad: {{ parserArrayTable(row.item.specialtis) }}</li>
                <li>Registro Médico: {{ row.item.medical_record }}</li>
                <li>Fecha de Nacimiento: {{ row.item.birth_date }}</li>
              </ul>
            </b-card>
          </template>
        </b-table>
      </b-row>
      <b-row class="mb-4 pb-4">
        <b-col sm="5" md="4">
          <label label-size="sm">{{ this.totalRows }}</label>
        </b-col>
        <b-col sm="7" md="8">
          <b-pagination
            v-model="currentPage"
            :total-rows="paginationItems"
            :per-page="perPage"
            align="right"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>

    <CreateUser ref="formComponent"></CreateUser>
  </div>
</template>

<script>
import CreateUser from "@/components/admin/user/Create";

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      pageOptions: [10, 30, 50],
      fields: [
        { key: "first_name", label: "Nombre", sortable: true },
        { key: "documen", label: "Documento", sortable: true },
        { key: "username", label: "Usuario", sortable: true },
        { key: "email", label: "Correo", sortable: true },
        { key: "is_active", label: "Estado", sortable: true },
        { key: "roles", label: "Roles", sortable: true, width: "10" },
        { key: "action", label: "" }
      ],
      items: [],
      showIndex: true,
      form: {
        rolesTable: "",
        rhOptions: null,
        rolOptions: null,
        specialtyOptions: null,
        typeDocumentOptions: null,
        titleAction: "",
        buttonText: "",
        actionSave: null
      },
      detailsShowing: false,
      filter: null,
      filterOn: [],
      totalRows: null,
      paginationItems: 0,
      totalItems: 0
    };
  },
  watch: {
    items: function (val) {
      this.totalItems = val.length
      this.totalRows = this.getCountItems(val.length)
      this.paginationItems = val.length 
    },
    currentPage: function (val) {
      this.totalRows = this.getCountItems(this.totalItems)      
    },
    perPage: function (val) {
      this.totalRows = this.getCountItems(this.totalItems)      
    }    
  },
  methods: {
    onClickCreate() {
      this.loadOptionsForm();
      this.form.titleAction = "Crear Usuario";
      this.form.buttonText = "Guardar";
      this.$refs.formComponent.showCreate = true;
      this.showIndex = false;
      this.$refs.formComponent.actionSave = true;
    },
    onClickEdit(userId) {
      const left = this;
      this.axios
        .get(this.$apiURI_users + "/api/v1/users/" + userId)
        .then(function(response) {
          left.$refs.formComponent.loadDataForm(response.data);
          left.loadOptionsForm();
          left.$refs.formComponent.showCreate = true;
          left.showIndex = false;
          left.$refs.formComponent.actionSave = false;
          left.form.titleAction = "Modificar Usuario";
          left.form.buttonText = "Actualizar";
        });
    },
    onClickCancel() {
      this.form.showCreate = false;
    },
    onChangeStatusUser: function(evt) {
      const left = this;
      this.axios
        .put(this.$apiURI_users + "/api/v1/users/status", {
          id: evt.target.id,
          status: evt.target.checked
        })
        .then(response => {
          left.$bvToast.toast("Estado actualizado con exito", {
            title: "Datos Actualizados",
            autoHideDelay: 3000,
            variant: "success"
          });
          left.listUsers();
        });
    },
    listUsers() {
      this.axios.get(this.$apiURI_users + "/api/v1/users").then(response => {
        this.items = response.data;
      });
    },
    loadOptionsForm() {
      if (
        this.rhOptions == null ||
        this.rolOptions == null ||
        this.specialtyOptions == null ||
        this.typeDocumentOptions == null
      ) {
        this.axios
          .get(this.$apiURI_users + "/api/v1/user/rhs")
          .then(response => {
            this.form.rhOptions = response.data;
          });

        this.axios
          .get(this.$apiURI_users + "/api/v1/user/specialtis")
          .then(response => {
            this.form.specialtyOptions = response.data;
          });

        this.axios
          .get(this.$apiURI_users + "/api/v1/user/documents")
          .then(response => {
            this.form.typeDocumentOptions = response.data;
          });

        this.axios
          .get(this.$apiURI_users + "/api/v1/user/roles")
          .then(response => {
            this.form.rolOptions = response.data;
          });
      }
    },
    parserArrayTable(data) {
      var parser = null;
      data.forEach(element => {
        if (parser != null) {
          parser = parser + ", " + element.description;
        } else {
          parser = element.description;
        }
      });
      return parser;
    },
    onFiltered(filteredItems) {
      this.currentPage = 1;
      this.totalItems = filteredItems.length
      this.totalRows = this.getCountItems(filteredItems.length)
      this.paginationItems = filteredItems.length 
    },
    getCountItems(items) {
      var countValue;
      var messageCount = null      
      if (items == 0) {
        messageCount = "Mostrando 0 de 0 registros";
      } else {     
        switch (this.currentPage) {
          case 1:
            countValue = this.perPage > items ? items : this.perPage
            messageCount = "Mostrando " + this.currentPage + " a " + countValue + " de " + items+ " registros"
            break;
          case 1:
            var initCount = this.perPage + this.perPage;
            countValue = initCount > items ? items : initCount;
            messageCount = "Mostrando " + (this.perPage + 1) + " a " + countValue + " de " + items + " registros";
            break;
          default:
            var initCount = (this.currentPage - 1) * this.perPage;
            countValue = initCount + this.perPage > items ? items : initCount + this.perPage;
            messageCount = "Mostrando " + (initCount + 1) + " a " + countValue + " de " + items + " registros";
            break;
        }
      }     
      return messageCount;
    }
  },
  mounted() {
    this.listUsers();
  },
  components: { CreateUser }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/user/Index.vue